import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  InitiateAuthCommandInput,
} from '@aws-sdk/client-cognito-identity-provider';
import axiosStatic from 'axios';
import { HttpClient } from './http-client';

const AWS_COGNITO_CLIENT_REGION = 'us-east-1';

class CognitoClient extends HttpClient {
  public loginWithCognitoSDK = async (payload) => {
    const awsCognitoClient = new CognitoIdentityProviderClient({
      region: AWS_COGNITO_CLIENT_REGION,
    });

    const userName = payload.userName.trim() + payload.userNamesuffix;

    const input: InitiateAuthCommandInput = {
      AuthFlow: 'USER_PASSWORD_AUTH',
      ClientId: payload.clientId,
      AuthParameters: {
        USERNAME: userName,
        PASSWORD: payload.password,
      },
    };

    const command = new InitiateAuthCommand(input);
    const { AuthenticationResult } = await awsCognitoClient.send(command);

    if (AuthenticationResult != null) {
      const { AccessToken } = AuthenticationResult;

      return { token: AccessToken };
    }

    return { token: null };
  };

  public loginWithCognitoCustomEndpoint = async (payload) => {
    const userName = payload.userName.trim() + payload.userNamesuffix;

    const response = await this.post('authentication/sign-in', {
      userName,
      password: payload.password,
      clientId: payload.clientId,
    });

    return response;
  };

  public loginWithCognito = async (payload, isCustomAuthentication) => {
    if (isCustomAuthentication) {
      return this.loginWithCognitoCustomEndpoint(payload);
    }

    return this.loginWithCognitoSDK(payload);
  };

  public loginWithCognitoSSO = async (
    issuerDomain,
    code,
    redirectURI,
    codeVerifier,
    clientId,
  ) => {
    const queryParams = new URLSearchParams({
      grant_type: 'authorization_code',
      code,
      redirect_uri: redirectURI,
      code_verifier: codeVerifier,
      client_id: clientId,
    });

    try {
      const response = await axiosStatic.post(
        `${issuerDomain}/oauth2/token?${queryParams.toString()}`,
        {},
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        },
      );

      return response.data;
    } catch (error: any) {
      throw new Error(`Login with Cognito SSO failed: ${error.message}`);
    }
  };
}

export const CognitoAPI = new CognitoClient();
